import { DraftOrder } from '../../types/orders';
import { Actions, ActionTypes } from './actions';

export interface State {
    isLoading: boolean;
    isNotFound: boolean;
    draft: DraftOrder | undefined;
}

export const initialState: State = {
    isLoading: false,
    isNotFound: false,
    draft: undefined,
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.GetDraftOrder:
            if (state.draft && state.draft.id === action.payload.id) {
                return { ...state };
            }
            return {
                ...state,
                draft: undefined,
                isLoading: true,
                isNotFound: false,
            };

        case ActionTypes.DraftOrderResponse:
            return {
                ...state,
                draft: action.payload.draft,
                isLoading: false,
                isNotFound: false,
            };

        case ActionTypes.DraftOrderNotFoundResponse:
            return {
                ...state,
                isLoading: false,
                isNotFound: true,
                draft: undefined,
            };

        default:
            return state;
    }
}
